module.exports = __webpack_public_path__ + "poppins-v5-devanagari_latin-ext_latin-700.2d54d876876ad1267bfe.woff";


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-700.woff
// module id = ../../../../../src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-700.woff
// module chunks = styles